module.exports = __webpack_public_path__ + "media/images/number_9_red-53ec8dbdddc22657643a03e06ae0f7db.png";